import { useTranslation } from "react-i18next";
import type { Decision } from "../../../api/access/decisions";
import AppButton from "../../../ui/buttons/AppButton";
import { useHerePath, useThreadPreparation } from "../../threads/prepare";

/** "Release…" (K-12, F2): at the top right of the Data model page, and in a project's
 * settings under Export (F11), as the decision on releasing says (`releaseDecision`, F17, GS-8):
 * whoever lacks Releases sees it locked, with who can add them. It opens the Thread view in
 * preparation for the release Workflow beside this page (Johannes, 27 Oct: release is a Thread
 * step). */
export default function ReleaseButton({ projectId, decision }: { projectId: string; decision: Decision }) {
  const { t } = useTranslation();
  const preparation = useThreadPreparation();
  const here = useHerePath();
  return (
    <AppButton variant="primary" size="sm" requires={decision} onClick={() => { preparation.prepare({ kind: "release", projectId, returnTo: here }); }}>
      {t("data.release.button")}
    </AppButton>
  );
}
